import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/members/new',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/MemberNewContainer',
      './modules/memberNew'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const MemberNew = require('./containers/MemberNewContainer').default
      const actions = require('./modules/memberNew')
      const reducer = require('./modules/memberNew').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'memberNew', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, MemberNew)

    /* Webpack named bundle   */
    }, 'memberNew')
  }
})




// WEBPACK FOOTER //
// ./src/routes/MemberNew/index.js